import { cn } from "../lib/utils"

export const Title = ({ children, className, variant = "default" }) => {
  const textVariants = {
    default: "text-3xl font-bold mb-4 text-brandSecondary",
    brand: "text-3xl font-bold mb-4 text-brand",
  }
  return <h1 className={cn(textVariants[variant], className)}>{children}</h1>
}
